module.exports = __webpack_public_path__ + "img/loader_background.e63e5039.svg";